export enum LanguageType {
  EN = "en",
  ZH_HK = "zh_HK",
  ZH_CN = "zh_CN",
  AR = "ar",
  ES = "es",
  FR = "fr",
  PT = "pt",
}
